import { configureStore } from '@reduxjs/toolkit';
import userAliasReducer from '../features/auth/userAliasSlice';
import { getCurEnv } from '../utils/envVarsReader';

export const store = configureStore({
    reducer: {
        userAlias: userAliasReducer,
    },
    devTools: getCurEnv() !== 'prod',  // disable devTools so redux state in prod so state won't be modified
});